module.exports = __webpack_public_path__ + "static/img/017.f64a270.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fushen/017.png
// module id = +qEA
// module chunks = 0